import { DONUT_COLORS } from './constants';

export const getTransportationProperties = (
  type: string,
  value: number | undefined,
) => {
  let donutColor = DONUT_COLORS.noRating;
  let possibility = 'Not Available';
  let description = 'Information Unavailable';
  if (!value) {
    return { ...donutColor, possibility, description };
  }
  if (value >= 90) {
    donutColor = DONUT_COLORS.good;
    switch (type) {
      case 'walk':
        possibility = 'Walker’s Paradise';
        description = 'Daily errands do not require a car';
        break;
      case 'transit':
        possibility = 'Rider’s Paradise';
        description = 'World-class public transportation';
        break;
      case 'bike':
        possibility = 'Biker’s Paradise';
        description = 'Daily errands can be accomplished on a bike';
        break;
    }
  } else if (value >= 70 && value < 90) {
    donutColor = DONUT_COLORS.good;
    switch (type) {
      case 'walk':
        possibility = 'Very Walkable';
        description = 'Most errands can be accomplished on foot';
        break;
      case 'transit':
        possibility = 'Excellent Transit';
        description = 'Transit is convenient for most trips';
        break;
      case 'bike':
        possibility = 'Very Bikeable';
        description = 'Biking is convenient for most trips';
        break;
    }
  } else if (value >= 50 && value < 70) {
    donutColor = DONUT_COLORS.orange;
    switch (type) {
      case 'walk':
        possibility = 'Somewhat Walkable';
        description = 'Some errands can be accomplished on foot';
        break;
      case 'transit':
        possibility = 'Good Transit';
        description = 'Many nearby public transportation options';
        break;
      case 'bike':
        possibility = 'Bikeable';
        description = 'Some bike infrastructure';
        break;
    }
  } else if (value >= 25 && value < 50) {
    donutColor = DONUT_COLORS.red;
    switch (type) {
      case 'walk':
        possibility = 'Car-Dependent';
        description = 'Most errands require a car';
        break;
      case 'transit':
        possibility = 'Some Transit';
        description = 'A few nearby public transportation options';
        break;
      case 'bike':
        possibility = 'Somewhat Bikeable ';
        description = 'Minimal bike infrastructure';
        break;
    }
  } else if (value >= 0 && value < 25) {
    donutColor = DONUT_COLORS.red;
    switch (type) {
      case 'walk':
        possibility = 'Car-Dependent';
        description = 'Almost all errands require a car';
        break;
      case 'transit':
        possibility = 'Some Transit';
        description = 'It is possible to get on a bus';
        break;
      case 'bike':
        possibility = 'Somewhat Bikeable';
        description = 'Minimal bike infrastructure';
        break;
    }
  }

  return { ...donutColor, possibility, description };
};

export const getScoundScoreProperties = (score: number | undefined) => {
  let donutColors = DONUT_COLORS.noRating;
  let description = 'Not Available';
  if (!score) {
    return { donutColors, description };
  }
  if (score === 100) {
    donutColors = DONUT_COLORS.blue;
    description = 'Very Quiet';
  } else if (score >= 85 && score < 100) {
    donutColors = DONUT_COLORS.lightBlue;
    description = 'Calm';
  } else if (score >= 75 && score < 85) {
    donutColors = DONUT_COLORS.good;
    description = 'Active';
  } else if (score >= 65 && score < 75) {
    donutColors = DONUT_COLORS.orange;
    description = 'Busy';
  } else if (score < 65) {
    donutColors = DONUT_COLORS.lightRed;
    description = 'Very Loud';
  }
  return { donutColors, description };
};

export const getFloodScoreProperties = (score: number | undefined) => {
  let donutColors = DONUT_COLORS.noRating;
  let possibility = 'Not Available';
  let description = 'Information Unavailable';
  if (!score) {
    return { donutColors, possibility, description };
  }
  if (score === 1) {
    donutColors = DONUT_COLORS.good;
    possibility = 'Minimal Risk';
    description = 'Flood insurance: Recommended, but not required';
  } else if (score === 2) {
    donutColors = DONUT_COLORS.average;
    possibility = 'Minor Risk';
    description = 'Flood insurance: Recommended, but not required';
  } else if (score === 3 || score === 4) {
    donutColors = DONUT_COLORS.lightOrange;
    possibility = 'Moderate Risk';
    description = 'Flood insurance: Recommended, but not required';
  } else if (score === 5 || score === 6) {
    donutColors = DONUT_COLORS.darkOrange;
    possibility = 'Major Risk';
    description = 'Flood Insurance: Required';
  } else if (score === 7 || score === 8) {
    donutColors = DONUT_COLORS.poor;
    possibility = 'Major Risk';
    description = 'Flood Insurance: Required';
  } else if (score === 9 || score === 10) {
    donutColors = DONUT_COLORS.darkRed;
    possibility = 'Extreme Risk';
    description = 'Flood Insurance: Required';
  }

  return { donutColors, possibility, description };
};
